export default [
  { value: "none", label: "Selecionar" },
  {
    value: "102",
    label: "102 - Tributada pelo Simples Nacional sem permissão de crédito."
  },
  { value: "300", label: "300 - Imune." },
  {
    value: "500",
    label:
      "500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação."
  }
];



// WEBPACK FOOTER //
// ./src/core/enum/csosn-values.enum.js